import DOMPurify from 'dompurify';

export const HTMLSanitizer = ({
  text,
  className,
}: {
  text: string;
  className?: string;
}) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        // eslint-disable-next-line @typescript-eslint/naming-convention
        __html: DOMPurify.sanitize(text ?? ''),
      }}
    />
  );
};

export const removeLineBreaksFromString = (str = '') =>
  str.replace(/(\r\n|\n|\r|\t)/gm, ' ');
